<template>
    <section class="collection-router">
        <div class="content is-hidden-tablet has-text-centered">
            <h3 v-t="'menu.collection'"></h3>
        </div>
        <router-link :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.white') } }" class="item" style="background-image: url(/assets/img/white-wines-bg.jpg?id=45124741)">
            <div class="inner">
                <h3>
                    {{ $t('collectionRouter.white')}}
                    <span v-t="'collectionRouter.cta'"></span>
                </h3>
            </div>
            <div class="spacer"></div>
        </router-link>
        <router-link :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.red') } }" class="item" style="background-image: url(/assets/img/red-wines-bg.jpg?id=45124741)">
            <div class="inner">
                <h3>
                    {{ $t('collectionRouter.red')}}
                    <span v-t="'collectionRouter.cta'"></span>
                </h3>
            </div>
            <div class="spacer"></div>
        </router-link>
        <router-link :to="{ name: $i18n.locale+'.collection.wine', params: { wine: $t('routes.wines.sparkling') } }" class="item" style="background-image: url(/assets/img/sparkling-wines-bg.jpg?id=45124741)">
            <div class="inner">
                <h3>
                    {{ $t('collectionRouter.sparkling')}}
                    <span v-t="'collectionRouter.cta'"></span>
                </h3>
            </div>
            <div class="spacer"></div>
        </router-link>
    </section>
</template>
<script>
    export default {

    }
</script>